// Battle record (GDD §42.1): AI victories per faction matchup + recent results.

import { FACTIONS } from '../../content/factions';
import { loadProfile, matchupTable } from '../../app/persistence';
import type { FactionId } from '../../content/types';
import { mapDef } from '../../content/map';

const FACTION_IDS = Object.keys(FACTIONS) as FactionId[];

function fmtDuration(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function ProfileScreen({ onBack }: { onBack: () => void }) {
  const results = loadProfile();
  const table = matchupTable();
  const recent = results.slice(-10).reverse();
  const wins = results.filter((r) => r.result === 'victory').length;

  return (
    <div className="menu screenpage screen-in">
      <h2>Battle Record</h2>
      <div className="sub">
        {results.length} match{results.length === 1 ? '' : 'es'} · {wins} victories
      </div>

      <div className="setupsection">
        <div className="sectiontitle">Victories by matchup (you × AI)</div>
        <table className="recordtable">
          <thead>
            <tr>
              <th></th>
              {FACTION_IDS.map((f) => (
                <th key={f} title={FACTIONS[f].name}>
                  {FACTIONS[f].mark}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {FACTION_IDS.map((pf) => (
              <tr key={pf}>
                <th title={FACTIONS[pf].name}>{FACTIONS[pf].mark}</th>
                {FACTION_IDS.map((af) => {
                  const cell = table.get(`${pf}|${af}`);
                  return (
                    <td key={af}>{cell ? `${cell.wins}–${cell.losses}` : '·'}</td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="setupsection">
        <div className="sectiontitle">Recent matches</div>
        {recent.length === 0 && <div className="sub">No matches recorded yet.</div>}
        {recent.map((r, i) => (
          <div key={i} className={`resultrow ${r.result === 'victory' ? 'won' : r.result === 'defeat' ? 'lost' : ''}`}>
            <span className="outcome">{r.result.toUpperCase()}</span>
            <span>
              {[r.playerFaction, ...r.allyFactions].map((f) => FACTIONS[f].mark).join('+')} vs{' '}
              {r.enemyFactions.map((f) => FACTIONS[f].mark).join('+')}
            </span>
            <span>{r.mode} · {mapDef(r.mapId).name}</span>
            <span>{fmtDuration(r.durationSec)}</span>
          </div>
        ))}
      </div>

      <div className="menubuttons row">
        <button className="btn primary" onClick={onBack}>
          ← Back
        </button>
      </div>
    </div>
  );
}
